__turbopack_context__.v({
  "menu": "landing-model-choice-module__BOHiNa__menu",
});
